import { createFileRoute } from '@tanstack/react-router'
import { CounterInterface } from '@/components/counter/CounterInterface'

function CounterRoutePage() {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden bg-background">
      <CounterInterface />
    </div>
  )
}

export const Route = createFileRoute('/admin/counter')({
  // Optional deep-link from the server floor's "Settle" action: preselect a
  // table so the Counter loads its open dine-in order and opens checkout.
  validateSearch: (search: Record<string, unknown>): { tableId?: string } => {
    const tableId = search.tableId
    return typeof tableId === 'string' && tableId ? { tableId } : {}
  },
  component: CounterRoutePage,
})
